const checkIsInFrame = () => {
  try {
    return window !== window.top;
  } catch (e) {
    return true;
  }
};

export default checkIsInFrame;
